import { useEffect } from "react";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import InnerSidebar from "layouts/InnerSidebar";
import CalendarPermissionsSettings from "features/Settings/Calendar/CalendarPermissionsSettings";

export default function CalendarSettingsPage() {
  const { setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("Calendar Settings");
    return () => setPageTitle(null);
  }, [setPageTitle]);

  return (
    <AppPage>
      <InnerSidebar>
        <CalendarPermissionsSettings />
      </InnerSidebar>
    </AppPage>
  );
}
